import { Register_Id, access_token, apiPort, urlPort } from "../../socket";

export function getCategoryData(id) {
    let categoryData = new Promise((resolve, reject) => {
        var myHeaders = new Headers();
        myHeaders.append("access_token", access_token);
        myHeaders.append("Register_Id", Register_Id);
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "entityName": "categories",
            "action": "payload",
            "pageUrl": "FetchGetCategories",
            "event": "replaceWithAuth",
            "formList": [
                {
                    "schd_type_desc": "Daily",
                    "oko_row_code": id,
                    "active_status": "1"
                }
            ]
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(apiPort, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result, " successful");
                resolve(result.data.Oken_Onboarding)
                // setcategoryData(result.data.Oken_Onboarding)
            })
            .catch(error => reject(error));
    })
    return categoryData

}

export function gotoBrand(mallCode) {
    let BrandData = new Promise((resolve, reject) => {
        var myHeaders = new Headers();
        myHeaders.append("access_token", access_token);
        myHeaders.append("Register_Id", Register_Id);
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "pageUrl": "BrandDbCallConvertion",
            "entityName": "dbcall",
            "action": "payload",
            "event": "replaceWithAuth",
            "formList": [
                {
                    "branch_Code": mallCode,
                    "category": "",
                    "userId": ""
                }
            ]
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(apiPort, requestOptions)
            .then(response => response.json())
            .then(result => {
                let datas = result.data.Party_File_Tmpl
                resolve(datas)
                // let selectBrand = datas.filter(d => d.category == category_name)
                // setBrandData(selectBrand)
            })
            .catch(error => reject(error));
    })
    return BrandData
}
export function getMallList() {
    let mallList = new Promise((resolve, reject) => {
        var myHeaders = new Headers();
        myHeaders.append("access_token", access_token)
        myHeaders.append("Register_Id", Register_Id);
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "entityName": "Oken_Onboarding",
            "action": "payloadRuleWithTid",
            "pageUrl": "FetchAllMallNew4",
            "event": "JR_1050",
            "formList": [
                {
                    "oko_Cat_Desc": "Mall",
                    "oko_Status": 1,
                    "branch_Status": 1
                }
            ]
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(apiPort, requestOptions)
            .then(response => response.json())
            .then(result => {
                resolve(result)
            })
            .catch(error => {
                reject(error)
                console.log('error', error)
            });
    })
    return mallList
}

// export function mallIdMiniApp() {
//     let miniApp = new Promise((resolve, reject) => {
//         fetch(urlPort + `/ApiData/${mallId}.json`).then(d => d.json()).then(d => {
//             resolve(d.data.miniApp)
//         }).catch(error => reject(error))
//     })
//     return miniApp
// }

export function BrandDetails(id) {
    let _BrandDetails = new Promise((resolve, reject) => {
        var myHeaders = new Headers();
        myHeaders.append("access_token", access_token)
        myHeaders.append("Register_Id", Register_Id);
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "entityName": "branddetails",
            "action": "payload",
            "pageUrl": "FetchBrandDetails",
            "event": "replaceWithAuth",
            "formList": [
                {
                    "Item": id,
                    "Status": 1
                }
            ]
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(apiPort, requestOptions)
            .then(response => response.json())
            .then(result => {
                // console.log(result.data.Oken_Onboarding,id);
                resolve(result.data.Oken_Onboarding)
            })
            .catch(error => {
                reject(error)
            });
    })
    return _BrandDetails
}
export function Sound(n) {
    var audio = new Audio('/Sound/sound' + n + '.mp3');
    audio.play();

}

